import React from 'react';
import LegalLinks from './LegalLinks';

type TermsConsentRowProps = {
  checked: boolean;
  onChange: (value: boolean) => void;
};

const TermsConsentRow: React.FC<TermsConsentRowProps> = ({ checked, onChange }) => {
  return (
    <label className="flex items-start gap-3 text-sm text-slate-700">
      <input
        type="checkbox"
        className="mt-1 h-4 w-4 rounded border-slate-300 text-[#C6A87C] focus:ring-[#C6A87C]"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span>
        I understand DisputeBot is not a law firm and does not provide legal advice. I agree to the{' '}
        <LegalLinks />.
      </span>
    </label>
  );
};

export default TermsConsentRow;
